export default "__VITE_ASSET__kj14V37k__"